const config = require("../config")

module.exports = {
    list: {
        url: config.base_dev_url + "chat/list",
        type: "get",
    },
    createSession: {
        url: config.base_dev_url + "chat/createSession",
        type: "get",
    },
    sendMsg: {
        url: config.base_dev_url + "chat/send",
        type: "post",
    },
    readUpdate: {
        url: config.base_dev_url + "chat/markRead",
        type: "get",
    },
    //获取会话列表（所有农场）
    getSessionListAll: {
        url: config.base_dev_url + "chat/sessionList",
        type: "get",
    },
    //获取会话列表（单个农场）
    sessionListByFarm: {
        url: config.base_dev_url + "chat/sessionListByFarm",
        type: "get",
    },
    //获取帖子详情
    postDetail: {
        url: config.base_dev_url + "bbs_post/detail",
        type: "get",
    }
}
